import $ from 'jquery';

const productRecommendations = {
    _format: function(data, ids) {
        var recommendations = data.recipients.reduce(function(arr, recipient) {
                return arr.concat(extendRecommendations(recipient));
            }, []),
            groupedByproductClassIds;

        if (ids) {
            recommendations = recommendations.filter(function(recommendation) {
                return ids.indexOf(recommendation.productClassId) > -1;
            });
        }

        groupedByproductClassIds = groupByProperty(recommendations, 'productClassId');

        return Object.keys(groupedByproductClassIds).reduce(
            function(arr, key) {
                arr.push(this._addResultText(groupedByproductClassIds[key]));

                return arr;
            }.bind(this),
            []
        );
    },
    buildAffectedRecipientString: function(groups, nameProperty) {
        var DISPLAY_LIMIT = 3,
            recipients = groups.map(pluck(nameProperty)),
            recipientNames,
            lastRecipient;

        if (groups.length < DISPLAY_LIMIT + 1) {
            if (groups.length > 1) {
                lastRecipient = recipients.pop();
                recipientNames = recipients.join(', ') + ' and ' + lastRecipient;
            } else {
                recipientNames = recipients.join(', ');
            }
        } else {
            recipientNames = recipients.slice(0, 3).join(', ') + ', +' + (groups.length - 3) + ' others';
        }

        return recipientNames;
    },
    _addResultText: function(groups) {
        var result = pluckProperties(['productClassId', 'categoryId', 'categoryName', 'justification'], groups[0]),
            affectedRecipientsText = this.buildAffectedRecipientString(groups, 'recipientName');

        result.resultText = addResultText(result.categoryName, affectedRecipientsText);
        result.justification = formatJustificationText(result.justification, affectedRecipientsText);

        return result;
    },
    dismissById: function(id) {
        return $.ajax({
            url: '/api/SupplementRecommendation/DismissWizardResultFromDisplayForCustomer/' + id,
            type: 'PUT',
            data: null,
            contentType: 'application/json'
        });
    },
    _fetchData: function() {
        return fetch('/api/SupplementRecommendation/GetCustomerRecommendations', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(response => response.json());
    },
    getByAccountId: function(accountId) {
        return this._fetchData().then(function(response) {
            return (
                response.status === smartPak.HTTP_STATUS_OK && {
                    smartSuggestions: smartSuggestionsByAccountId(response.content.smartSuggestions, accountId),
                    supplementWizardResults: wizardRecommendationsByAccountId(
                        response.content.supplementWizardResults,
                        accountId
                    )
                }
            );
        });
    },
    get: function(IDs) {
        return this._fetchData().then(
            function(response) {
                return (
                    response.status === smartPak.HTTP_STATUS_OK && {
                        smartSuggestions: response.content.smartSuggestions,
                        supplementWizardResults: this._format(response.content.supplementWizardResults, IDs)
                    }
                );
            }.bind(this)
        );
    }
};

function addResultText(categoryName, affectedRecipientsText) {
    return categoryName + ' Recommendation for <strong>' + affectedRecipientsText + '</strong>';
}

function formatJustificationText(justification, affectedRecipientsText) {
    return justification.replace(/your horse/gi, affectedRecipientsText);
}

function wizardRecommendationsByAccountId(results, recipientId) {
    var recipient = results.recipients.filter(function(recipient) {
        return recipient.recipientId === recipientId;
    })[0];

    return recipient && recipient.recommendations
        ? extendRecommendations(recipient).map(function(recommendation) {
              recommendation.justification = formatJustificationText(
                  recommendation.justification,
                  recipient.recipientName
              );
              recommendation.resultText = addResultText(recommendation.categoryName, recipient.recipientName);
              return recommendation;
          })
        : [];
}

function smartSuggestionsByAccountId(suggestions, accountId) {
    suggestions.accountSuggestions = suggestions.accountSuggestions.filter(function(suggestion) {
        return suggestion.accountId === accountId;
    });

    return suggestions;
}

function groupByProperty(arr, property) {
    return arr.reduce(function(obj, item) {
        if (!obj[item[property]]) {
            obj[item[property]] = [];
        }

        obj[item[property]].push(item);

        return obj;
    }, {});
}

function extendRecommendations(recipient) {
    return recipient.recommendations.map(function(recommendation) {
        return $.extend({}, recommendation, pluckProperties(['recipientId', 'recipientName'], recipient));
    });
}

function pluckProperties(properties, obj) {
    return properties.reduce(function(result, prop) {
        result[prop] = obj[prop];
        return result;
    }, {});
}

function pluck(prop) {
    return function(obj) {
        return obj[prop];
    };
}

export default productRecommendations;
